import { Action } from 'redux';
import { ACTION_CREATOR_NAME, analyticsHelper } from 'helpers';
import { PaymentActionTypes } from 'store/payment';
import { PaypalAuthModel } from 'models/Payment';

export interface PaypalSetAuthResultAction extends Action<PaymentActionTypes.PAYPAL_SET_AUTH_RESULT> {
    paypalAuthResult: PaypalAuthModel;
}

export const paypalSetAuthResult: (paypalAuthResult: PaypalAuthModel) => PaypalSetAuthResultAction = (paypalAuthResult: PaypalAuthModel) => ({
    type: PaymentActionTypes.PAYPAL_SET_AUTH_RESULT,
    paypalAuthResult
});
paypalSetAuthResult[ACTION_CREATOR_NAME] = 'paypalSetAuthResult';

export type PaypalSetAuthResultFunc = (...args: Parameters<typeof paypalSetAuthResult>) => void;

export function* paypalSetAuthResultSaga() {
    yield sendAnalytics();
}

function* sendAnalytics(): Generator<any, void, any> {
    yield analyticsHelper.withLoggingGenerator(function* () {
        yield analyticsHelper.sendToGooglePaypalPaymentStatus('paypalCompleted');
    }, 'paypalSetAuthResultSaga');
}